import { render, staticRenderFns } from "./54zhsq.vue?vue&type=template&id=52bc86cd&"
import script from "./54zhsq.vue?vue&type=script&lang=js&"
export * from "./54zhsq.vue?vue&type=script&lang=js&"
import style0 from "./54zhsq.vue?vue&type=style&index=0&id=52bc86cd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports